// Import Actions
import { SET_VAT_RATES } from './VatActions.js';

// Initial State
export const initialState = {
	data: [],
};

const VatReducer = (state = initialState, action = {}) => {
	switch(action.type) {
		case SET_VAT_RATES:
			return {
				...state,
				data: action.vatRates || [],
			};

		default:
			return state;
	}
};

export default VatReducer;
